//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'center-grid',
    props: {
        items: Array,
    },
    data() {
        return {
            items6: []
        }
    },
    watch: {
        items: {
            immediate: true,
            handler: function (items) {
                //居中，填补空位，一行数据则双倍高度显示。
                let arr = [...items]; //items是父组件的数据，不要变动
                const empty = { content: '' };
                if (arr.length === 5) arr.splice(4, 0, empty);
                else if (arr.length === 4) arr = [arr[0], arr[1], arr[2], empty, arr[3], empty];
                else if (arr.length === 3) arr.push({}, {}, {});
                else if (arr.length === 2) arr = [arr[0], empty, arr[1], {}, {}, {}];
                else if (arr.length === 1) arr = [empty, arr[0], empty, {}, {}, {}];
                this.items6 = arr
            }
        }
    },
    methods: {
        clickItem(item) {
            if (item.xpath) {
                this.$x.jumpMenu(item);
            }
        }
    }
}
